import { useState } from 'react'

import AtomSwitch from '@/components/Atoms/AtomSwitch/AtomSwitch'
import ExcelFileUploader from '@/components/NomenclatureImport/Excel/ExcelFileUploader/ExcelFileUploader'
import PluralImportCollapse from '@/components/NomenclatureImport/PluralImport/PluralImport'
import SingularImport from '@/components/NomenclatureImport/SingularImport/SingularImport'
import { useUserInfoStore } from '@/stores/user/userInfoStore'

import cn from './NomenclatureImport.module.scss'

type LoadingType = 'singular' | 'plural'

const LOADING_TYPE_OPTIONS = [
  { value: 'singular' as const, label: 'Одиночная' },
  { value: 'plural' as const, label: 'Множественная' },
]

function NomenclatureImport() {
  const [loadingType, setLoadingType] = useState<LoadingType>('singular')
  const isOrganisationSelected = useUserInfoStore(
    (state) => Object.keys(state.selectedOrganisation).length > 0
  )

  return (
    <section className={cn.nomenclatureImport}>
      <div className={cn.loadingTypeSelection}>
        <AtomSwitch
          options={LOADING_TYPE_OPTIONS}
          value={loadingType}
          onChange={setLoadingType}
          ariaLabel="Тип загрузки"
          isOrganisationSelected={isOrganisationSelected}
        />
      </div>
      {loadingType === 'singular' && (
        <SingularImport isOrganisationSelected={isOrganisationSelected} />
      )}
      {loadingType === 'plural' && (
        <ExcelFileUploader
          previewDataColumnMappingProto={{
            articleColumnNumber: -1,
            articleInchColumnNumber: -1,
            descriptionColumnNumber: -1,
            brandColumnNumber: -1,
            unitOfMeasurementColumnNumber: -1,
            itemLengthColumnNumber: -1,
            itemWidthColumnNumber: -1,
            itemHeightColumnNumber: -1,
            itemWeightColumnNumber: -1,
            detailsColumnNumber: -1,
            warrantyColumnNumber: -1,
            commentColumnNumber: -1,
            multiplicityColumnNumber: -1,
            barcodeColumnNumber: -1,
            countryOfOriginColumnNumber: -1,
            categoryColumnNumber: -1,
          }}
        >
          <PluralImportCollapse />
        </ExcelFileUploader>
      )}
    </section>
  )
}

export default NomenclatureImport
